module.exports = __webpack_public_path__ + "img/link05.68b70398.gif";